module.exports = __webpack_public_path__ + "static/media/picture5.37ead327.jpg";